export type IssueStatus = 'OPEN' | 'IN_PROGRESS' | 'RESOLVED' | 'CLOSED';
export type tradeGroup =
  | 'ELECTRICAL'
  | 'MECHANICAL'
  | 'PLUMBING'
  | 'FIRE'
  | 'ARCHITECTURAL'
  | 'STRUCTURAL';

export type InspectionIssue = {
  id: number;
  floorPlanId: number;
  xAxis: string;
  yAxis: string;
  title: string;
  description: string | null;
  notes: string | null;
  status: IssueStatus;
  tradeGroup: tradeGroup | null;
  actionBy: string | null;
  actionByDate: string | null;
  resolutionDate: string | null;
  createdAt: string;
  updatedAt: string;
  archivedAt: string | null;
  deletedAt: string | null;
  options: unknown[];
  photos: InspectionPhotos[];
};

type InspectionPhotos = {
  id: number;
  inspectionIssueId: number;
  photoId: number;
  photoType: string;
  createdAt: string;
  updatedAt: string;
  archivedAt: string;
  url: string;
};

export type GetInspectionIssuesResponse = {
  success: boolean;
  message: string;
  total: number;
  issues: InspectionIssue[];
};

export const STATUS_LABEL: Record<IssueStatus, string> = {
  OPEN: 'Open',
  IN_PROGRESS: 'In Progress',
  RESOLVED: 'Resolved',
  CLOSED: 'Closed'
};

export const TRADE_LABEL: Record<tradeGroup, string> = {
  ELECTRICAL: 'Electrical',
  MECHANICAL: 'Mechanical',
  PLUMBING: 'Plumbing',
  FIRE: 'Fire',
  ARCHITECTURAL: 'Architectural',
  STRUCTURAL: 'Structural'
};

export const STATUS_COLOR: Record<IssueStatus, string> = {
  OPEN: '#DC2626',
  IN_PROGRESS: '#D97706',
  RESOLVED: '#16A34A',
  CLOSED: '#6B7280'
};

export const TRADE_COLOR: Record<string, string> = {
  E: '#2563EB', // Electrical
  M: '#16A34A', // Mechanical
  P: '#0D9488', // Plumbing
  F: '#DC2626', // Fire
  A: '#EA580C', // Architectural
  S: '#7C3AED' // Structural
};

export type FloorPlanIssuePayload = {
  xAxis: number;
  yAxis: number;
  description?: string;
};

export type Size = { w: number; h: number };

export type Point = { x: number; y: number };

export type IssueMarker = {
  id: string;
  issueId: number | null;
  xPct: number;
  yPct: number;
  details: string;
  status: string | null;
};

export type IssueModalState = {
  visible: boolean;
  id: string;
  xPct: number;
  yPct: number;
  text: string;
};

export type ViewState = {
  pan: Point;
  scale: number;
  base: Size;
  container: Size;
};
